/* ==========================================================================
   REWORN — cursor.js
   The pixel hand, rendered as an element so it can animate.

   A CSS `cursor: url(...)` image cannot tween, so the native cursor is
   hidden and this draws the hand instead. Position is written straight to a
   transform on every pointer event — no easing, no lag — while the *scale*
   is what tweens: it presses in on pointerdown and springs back on release.

   Desktop pointers only. If this script never runs, the CSS image cursor in
   ios.css is still there as the fallback, so nobody ends up with no cursor.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.documentElement;
  var flagged = root.getAttribute('data-cursor') === 'hand' ||
    (document.body && document.body.getAttribute('data-cursor') === 'hand');
  if (!flagged) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var HOTSPOT_X = 6;      // fingertip, matching the CSS fallback
  var HOTSPOT_Y = 1;

  var el = document.createElement('div');
  el.className = 'cur';
  el.setAttribute('aria-hidden', 'true');
  el.innerHTML = '<img alt="" draggable="false">';
  var img = el.firstChild;
  img.src = root.getAttribute('data-cursor-src') ||
    (document.body && document.body.getAttribute('data-cursor-src')) || '';

  var ready = false;
  var x = -100;
  var y = -100;
  var pending = false;

  function paint() {
    pending = false;
    el.style.transform =
      'translate3d(' + (x - HOTSPOT_X) + 'px,' + (y - HOTSPOT_Y) + 'px,0)';
  }

  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(paint);
  }

  function attach() {
    if (ready) return;
    ready = true;
    document.body.appendChild(el);
    // Only hide the native cursor once ours is definitely on screen
    root.classList.add('js-cursor');
  }

  // Fields keep the native caret — a novelty pointer in a text input is worse
  function isTextish(node) {
    if (!node || !node.closest) return false;
    return !!node.closest('input[type="text"], input[type="email"], input[type="search"], input[type="password"], input[type="tel"], input[type="number"], textarea, [contenteditable="true"]');
  }

  document.addEventListener(
    'pointermove',
    function (event) {
      if (event.pointerType !== 'mouse') return;
      attach();
      x = event.clientX;
      y = event.clientY;
      el.setAttribute('data-hidden', isTextish(event.target) ? 'true' : 'false');
      schedule();
    },
    { passive: true }
  );

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    el.setAttribute('data-down', 'true');
  });

  function release() {
    el.setAttribute('data-down', 'false');
  }

  document.addEventListener('pointerup', release);
  document.addEventListener('pointercancel', release);
  window.addEventListener('blur', release);

  document.addEventListener('mouseleave', function () {
    el.setAttribute('data-hidden', 'true');
  });

  document.addEventListener('mouseenter', function () {
    el.setAttribute('data-hidden', 'false');
  });
})();
